module.exports = __webpack_public_path__ + "38dd39459df807f0a2bea7a4a3536007.fbx";